import { z } from "zod";

import { DateIsoString } from "@/core/types";
import { CurrencyCodelist } from "@/data/codelists";

import { TimeReportGuid, TimeReportSystemId } from "./TimeReport";
import { TimeReportStageCodelist } from "./TimeReportStage";

export const TimeReportVersion = z.object({
  guid: TimeReportGuid,
  systemId: TimeReportSystemId,
  creationDate: DateIsoString,
  stage: TimeReportStageCodelist,
  version: z.number(),
  totalReportedMinutes: z.number(),
  totalReportedDays: z.number().nullish(),
  totalReportedCost: z.number().nullable(),
  currency: CurrencyCodelist,
});

export type TimeReportVersion = z.infer<typeof TimeReportVersion>;
